import {
  PersonAdd,
  MonetizationOn,
  CheckCircle,
  AccountBalanceWallet,
  VerifiedUser,
  ListAlt,
  Assessment,
  AccountTree,
  Campaign,
  LocalHospital,
} from "@mui/icons-material";

export const AdminSideBarMenuItems = [
  {
    Icon: <AccountTree sx={{ height: "18px", width: "18px" }} />,
    path: "/admin/user-network",
    title: "User Network",
    active: true,
    isAdmin: true,
  },
  {
    Icon: <VerifiedUser sx={{ height: "18px", width: "18px" }} />,
    path: "/admin/kyc-management",
    title: "KYC Management",
    active: true,
    isAdmin: true,
  },
  {
    Icon: <AccountBalanceWallet sx={{ height: "18px", width: "18px" }} />,
    path: "/users-detail-withdrawal",
    title: "Users Wallet",
    active: true,
    isAdmin: true,
  },
  {
    Icon: <MonetizationOn sx={{ height: "18px", width: "18px" }} />,
    path: "/admin/commission",
    title: "Add Commission",
    active: true,
    isAdmin: true,
  },
  {
    Icon: <PersonAdd sx={{ height: "18px", width: "18px" }} />,
    path: "/user-quotas",
    title: "Member Levels",
    active: true,
    isAdmin: true,
  },
  {
    Icon: <CheckCircle sx={{ height: "18px", width: "18px" }} />,
    path: "/user-withdrawal",
    title: "Pending Withdrawals",
    active: true,
    isAdmin: true,
  },
  {
    Icon: <Assessment sx={{ height: "18px", width: "18px" }} />,
    path: "/approved-withdrawal",
    title: "Approved Withdrawals",
    active: true,
    isAdmin: true,
  },
  {
    Icon: <LocalHospital sx={{ height: "18px", width: "18px" }} />,
    path: "/create-form-options",
    title: "Manage Hospitals",
    active: true,
    isAdmin: true,
  },
  {
    Icon: <Campaign sx={{ height: "18px", width: "18px" }} />,
    path: "/admin/notifications",
    title: "Notifications",
    active: true,
    isAdmin: true,
  },
  {
    Icon: <ListAlt sx={{ height: "18px", width: "18px" }} />,
    path: "/form-responses",
    title: "Form Responses",
    active: true,
    isAdmin: true,
  },
];
